import { useKeycloak } from '@State/Keycloak/KeycloakProvider';
import { useEffect, useState } from 'react';

interface useLoginUrlProps {
  returnUrl?: string;
}

const defaultReturnUrl = `${window.location.origin}/#/`;

export const useLoginUrl = ({ returnUrl }: useLoginUrlProps = {}) => {
  const { keycloak, initialized } = useKeycloak();
  const [loginUrl, setLoginUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!initialized) {
      setLoginUrl(null);
      return;
    }

    let cancelled = false;
    keycloak.redirectUri = returnUrl ?? defaultReturnUrl;

    keycloak
      .createLoginUrl()
      .then((url) => {
        if (!cancelled) {
          setLoginUrl(url);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setLoginUrl(null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [initialized, keycloak, returnUrl]);

  return loginUrl;
};
